/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_H1Inputs */

const en_contact_h1 = /** @type {(inputs: Contact_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us`)
};

const ko_contact_h1 = /** @type {(inputs: Contact_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의하기`)
};

const ja_contact_h1 = /** @type {(inputs: Contact_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

/**
* | output |
* | --- |
* | "Contact us" |
*
* @param {Contact_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_h1 = /** @type {((inputs?: Contact_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_h1(inputs)
	if (locale === "ko") return ko_contact_h1(inputs)
	return ja_contact_h1(inputs)
});